import { ItemId, TreeData } from '@atlaskit/tree'

import { AddMenuPointForm } from '../components/AddMenuPointDialog'

import { convertMenuPointActionsToRequestData } from './convertMenuPointActionsToRequestData'

export const buildMenuPointRequestData = (
  data: Record<string, unknown>,
  order: number,
  tree?: TreeData | null,
  treeItemId?: ItemId
) => {
  const treeItemData = tree && treeItemId ? tree.items[treeItemId]?.data : undefined
  const {
    childrenMenu: _childrenMenu,
    treeItemParentId: _treeItemParentId,
    expanded: _expanded,
    ...treeData
  } = treeItemData ?? {}

  const {
    childrenMenu: _dataChildrenMenu,
    treeItemParentId: _dataTreeItemParentId,
    expanded: _dataExpanded,
    ...elementData
  } = data

  const merged = treeItemData ? { ...treeData, ...elementData } : elementData
  const actionsSource = (merged as AddMenuPointForm).actions ?? treeItemData?.actions

  return {
    ...merged,
    order,
    actions: convertMenuPointActionsToRequestData(actionsSource) ?? [],
    commandParameters: merged.commandParameters ?? [],
    commandBody: merged.commandBody ?? [],
  }
}
